export class StoreIdRequiredError extends Error {
    constructor() {
        super('Store ID is required');
        this.name = 'StoreIdRequiredError';
    }
}
